import React, { useState ,useEffect,useRef} from "react";
import Avtar from "../../../img/undraw_profile.svg";
import {Link} from "react-router-dom";
import { signOut } from "firebase/auth"
import { auth } from "../../../firebase.config";
import Breadcrumb from '../../../utils/breadcrumb';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { faSignOutAlt } from '@fortawesome/free-solid-svg-icons';

const Header = ({authData}) =>{ 
    const[isOpen,setIsOpen] = useState(false);
    const dropdownRef = useRef(null);
    const userName =JSON.parse(authData)['name']  //useSelector((state) => state.authReducer.user_name)
    useEffect(() => {
        const handleClickOutside = (event) => {
          if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
            setIsOpen(false);
          }
        };
    
        document.addEventListener("click", handleClickOutside);
        return () => {
          document.removeEventListener("click", handleClickOutside);
        };
      }, []);

    const logoutHandle = () =>{
        signOut(auth).then(() => {
            localStorage.removeItem("able-auctions");
            window.location.href = '/login';
          }).catch((error) => {
            // An error happened.
          });
    }
    const handleClick = () =>{
        setIsOpen(!isOpen)
    }
    return(
        <>
            <nav className="navbar navbar-expand navbar-light bg-white topbar mb-2 static-top shadow">
                <Link className="text-decoration-none" to="/">
                    <img width={150} src={require("../../../img/able_auctions_logo.png")} alt="logo" className="logo"/>
                </Link>
                <button id="sidebarToggleTop" className="btn btn-link d-md-none rounded-circle mr-3">
                    <i className="fa fa-bars"></i>
                </button>
                <ul className="navbar-nav ml-auto">
               
                {/* <FontAwesomeIcon icon={icon({name: 'user-secret'})} /> 
                <FontAwesomeIcon icon={icon({name: 'coffee', style: 'regular'})} /> 
                <FontAwesomeIcon icon={icon({name: 'coffee', family: 'sharp', style: 'solid'})} />   */}



                    {/* <div className="topbar-divider d-none d-sm-block"></div> */}
                    {/* <!-- Nav Item - User Information --> */}
                    <li className="nav-item dropdown no-arrow" ref={dropdownRef}>
                        <button className="nav-link dropdown-toggle logout-btn" id="userDropdown" 
                            data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" onClick={handleClick}>
                            <span className="mr-2 d-none d-lg-inline text-gray-600 small text-capitalize">{userName}</span>
                            <img className="img-profile rounded-circle" src={Avtar} alt={"user"}/>
                        </button>
                        {/* <!-- Dropdown - User Information --> */}
                        {isOpen && (
                        <div className="dropdown-menu dropdown-menu-right shadow animated--grow-in show" aria-labelledby="userDropdown">
                            <button className="dropdown-item logout-btn"  data-toggle="modal" onClick={logoutHandle}>
                                <FontAwesomeIcon icon={faSignOutAlt} className="mr-2" />
                                Logout
                            </button>
                        </div>
                        )}
                    </li>

                </ul>
            </nav>
            <Breadcrumb/>
            <hr style={{marginTop:0}}/>
    </>
    );
}
export default Header